import { SkipForward, Disc3 } from "lucide-react";
import { fmtTime } from "@/lib/api";

const Deck = ({ label, track, elapsed, active, children, testid }) => {
  const remaining = track?.duration ? track.duration - elapsed : 0;
  const pct = track?.duration ? Math.min(100, (elapsed / track.duration) * 100) : 0;
  return (
    <div className="deck p-5 flex flex-col gap-4 min-w-0" data-testid={testid}>
      <div className="flex items-center justify-between">
        <span className="eyebrow">{label}</span>
        {active && track && <span className="font-mono text-[0.65rem] text-[color:var(--green)] tracking-widest">PLAYING</span>}
      </div>
      <div className="flex items-center gap-4 min-w-0">
        <Disc3 className={`w-12 h-12 shrink-0 ${active && track ? "vinyl-spin text-[color:var(--gold)]" : "text-white/20"}`} />
        <div className="min-w-0">
          <p className="font-display text-3xl leading-none truncate" data-testid={`${testid}-title`}>{track?.title || "Empty deck"}</p>
          <p className="text-sm text-[color:var(--lr-muted)] truncate mt-1">{track?.artist || (track ? "Unknown artist" : "Nothing loaded")}</p>
        </div>
      </div>
      {active ? (
        <>
          <div className="h-2 rounded-full bg-black/50 overflow-hidden">
            <div className="h-full bg-gradient-to-r from-[#00E676] via-[#FFB800] to-[#E62645] transition-[width] duration-500" style={{ width: `${pct}%` }} />
          </div>
          <div className="flex items-end justify-between">
            <span className="font-mono text-sm text-[color:var(--lr-muted)]">{fmtTime(track ? elapsed : 0)}</span>
            <div className="text-right">
              <span className="block font-mono text-[0.6rem] tracking-widest text-[color:var(--lr-muted)]">REMAINING</span>
              <span className={`font-mono text-3xl font-bold ${track && remaining < 15 ? "text-[color:var(--red)]" : "text-white"}`} data-testid="studio-time-remaining">-{fmtTime(remaining)}</span>
            </div>
          </div>
        </>
      ) : (
        <p className="font-mono text-sm text-[color:var(--lr-muted)]">Length {fmtTime(track?.duration)}</p>
      )}
      {children}
    </div>
  );
};

export const Decks = ({ state, elapsed, onSkip }) => (
  <section className="grid gap-4 md:grid-cols-[1.5fr_1fr]">
    <Deck label="Deck A / On air" track={state?.now_playing} elapsed={elapsed} active testid="studio-deck-a">
      <button onClick={onSkip} disabled={!state?.now_playing} className="self-start rounded-lg border border-white/15 px-4 py-2 text-sm font-semibold flex items-center gap-2 hover:bg-white/10 disabled:opacity-40 transition-colors" data-testid="studio-skip-track-button">
        <SkipForward className="w-4 h-4" /> Skip track
      </button>
    </Deck>
    <Deck label="Deck B / Up next" track={state?.queue?.[0]} elapsed={0} testid="studio-deck-b" />
  </section>
);
